import { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

export function fromBcsProductKey(key: BcsProductKey | undefined) {
  if (key === undefined) {
    return undefined;
  }
  const { source, subType, code } = key;
  return `${source}:${subType ?? ''}:${code}`;
}
